export default "__VITE_ASSET__JWw3wfLe__"